let cscount = 0;
const { SelectControl } = wp.components;
class Columns extends React.Component{
    constructor(props){
        super(props);
        this.state = {cols: props.cols, colspad: props.colspad, colsphone: props.colsphone, label: props.label, tabClass: '', tabContentClass: ''};
    }

    showTab(e){
        jQuery('#columnSelectorTab a.nav-link').removeClass('active');
        jQuery(e.currentTarget).addClass('active');
        jQuery('#columnSelectorTabContent .tab-pane').removeClass('active');
        jQuery(jQuery(e.currentTarget).attr('href')).addClass('active');
    }

    render(){

        return (
            <div className={"tab-container"}>
                <label>{this.state.label}</label>
                <ul className="nav nav-tabs" id="columnSelectorTab" role="tablist">
                    <li className={"nav-item"} role="presentation">
                        <a className="nav-link active" onClick={this.showTab} id="home-tab" data-toggle="tab" href="#pc" role="tab"
                           aria-controls="home" aria-selected="true"><span className="dashicons dashicons-laptop"></span></a>
                    </li>
                    <li className="nav-item" role="presentation">
                        <a className="nav-link" onClick={this.showTab} id="contact-tab" data-toggle="tab" href="#tablet" role="tab"
                           aria-controls="contact" aria-selected="false"><span className="dashicons dashicons-tablet"></span></a>
                    </li>
                    <li className="nav-item" role="presentation">
                        <a className="nav-link" onClick={this.showTab} id="profile-tab" data-toggle="tab" href="#phone" role="tab"
                           aria-controls="profile" aria-selected="false"><span className="dashicons dashicons-smartphone"></span></a>
                    </li>
                </ul>
                <div className="tab-content" id="columnSelectorTabContent" style={{
                    border: "1px solid #dddddd",
                    borderTop: 0,
                    padding: "15px"
                }}>
                    <div className="tab-pane active" id="pc" role="tabpanel" aria-labelledby="pc-tab">
                        <SelectControl
                            value={this.state.cols}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'1 Column', value:1},{label: "2 Columns", value:2},{label: "3 Columns", value:3},{label: "4 Columns", value:4},{label: "6 Columns", value:6},{label: "12 Columns", value:12}]}
                            /*onChange={ ( cols ) => { this.attributes.cols = cols }  }*/
                            onChange={ ( cols ) => {
                                this.setState({cols: cols});
                                this.props.onChange({cols: cols});
                            } }
                        />
                    </div>
                    <div className="tab-pane" id="tablet" role="tabpanel" aria-labelledby="tablet-tab">
                        <SelectControl
                            value={this.state.colspad}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'1 Column', value:1},{label: "2 Columns", value:2},{label: "3 Columns", value:3},{label: "4 Columns", value:4},{label: "6 Columns", value:6},{label: "12 Columns", value:12}]}
                            onChange={ ( cols ) => {
                                this.setState({colspad: cols});
                                this.props.onChange({colspad: cols});
                            } }
                        />
                    </div>
                    <div className="tab-pane" id="phone" role="tabpanel" aria-labelledby="phone-tab">
                        <SelectControl
                            value={this.state.colsphone}
                            class={"form-control wpdm-custom-select"}
                            options={[{label:'1 Column', value:1},{label: "2 Columns", value:2},{label: "3 Columns", value:3},{label: "4 Columns", value:4},{label: "6 Columns", value:6},{label: "12 Columns", value:12}]}
                            onChange={ ( cols ) => {
                                this.setState({colsphone: cols});
                                this.props.onChange({colsphone: cols});
                            } }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Columns;
